
import { StyleSheet } from '@react-pdf/renderer'

/** Espaçamento vertical entre seções (título do certificado, dados, composição, ensaios, bloco observações/assinatura). */
export const SECTION_VERTICAL_SPACING = 16

/** Distância entre o header fixo e o título “CERTIFICADO DE QUALIDADE”. */
export const CONTENT_TOP_AFTER_HEADER = 40

export const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    paddingTop: 40,
    paddingBottom: 20,
    paddingHorizontal: 40,
  },
  contentAfterHeader: {
    flexDirection: 'column',
    paddingTop: CONTENT_TOP_AFTER_HEADER,
    gap: SECTION_VERTICAL_SPACING,
  },
  header: {
    position: 'absolute',
    top: 10,
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottomWidth: 2,
    borderBottomColor: '#00BFD4',
    paddingBottom: 5,
    paddingHorizontal: 40,
  },
  logoContainer: {
    alignItems: 'flex-start',
  },
  logo: {
    width: 100,
    height: 40,
    objectFit: 'contain',
  },

  logoSubtitle: {
    fontSize: 10,
    marginTop: 2,
    color: '#000',
    paddingLeft: 10,
  },

  headerContact: {
    textAlign: 'right',
  },
  email: {
    fontSize: 9,
    marginTop: 28,
    color: '#929d9eff',
  },
  contact: {
    fontSize: 9,
    color: '#929d9eff',
  },
  footer: {
    position: 'absolute',
    bottom: 10,
    left: 0,
    right: 0,
    borderTopWidth: 2,
    borderTopColor: '#00BFD4',
    paddingTop: 6,
    textAlign: 'center',
    fontSize: 9,
  },
  footerTextBold: {
    fontWeight: 'bold',
    marginBottom: 2,
  },
  footerText: {
    fontSize: 9,
  },
  sectionTitleContainer: {
    textAlign: 'center',
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  sectionBlack: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#000',
  },
  sectionSubtitle: {
    fontSize: 11,
    color: '#00BFD4',
    textDecorationStyle: 'italic',
  },
  infoBlock: {
    gap: 4,
  },
  infoLine: {
    fontSize: 9,
  },
  infoLabel: {
    fontWeight: 'bold',
  },
  infoLabelSub: {
    fontWeight: 'normal',
    color: '#00BFD4',
  },
  infoValue: {
    color: '#000',
  },
  dataRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 5,
  },
  dataCellHeader: {
    fontSize: 8,
    fontWeight: 'bold',
    textAlign: 'center',
    width: '8%',
  },
  dataCellValue: {
    fontSize: 8,
    textAlign: 'center',
    width: '8%',
  },

  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    borderBottomWidth: 1,
    borderBottomColor: '#a3a1a1ff',
    marginBottom: 1,
  },
  tableHeaderCell: {
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 8,
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#ccc',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    minHeight: 30,
  },
  tableCell: {
    fontSize: 8,
    textAlign: 'center',
    padding: 8,
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#eee',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tableCellValue: {
    fontSize: 8,
    textAlign: 'center',
    padding: 8,
    flex: 1,
    fontWeight: 'bold',
    color: '#000',
  },
  observation: {
    width: '100%',
  },
  /** Coluna única: observações (4/5) + assinatura (1/5). Ajuste `minHeight` se precisar de mais área total. */
  observationSignatureColumn: {
    marginTop: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
  },
  observationSlot: {
    flex: 4,
    width: '100%',
  },
  signatureSlot: {
    flex: 1,
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  observationTitle: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#000000ff',
  },
  observationText: {
    fontSize: 9,
    color: '#000',
  },
  locationDate: {
    fontSize: 9,
    marginTop: 12,
    color: '#000',
  },
  additionalImageContainer: {
    marginTop: 100,
    paddingHorizontal: 20,
    textAlign: 'center',
  },
  imageTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  imageSubtitle: {
    fontSize: 12,
    marginBottom: 10,
    color: '#00BFD4',
  },
  imageFull: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
  },
  parentSignatureContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
  },
  signatureContainer: {
    textAlign: 'center',
    alignItems: 'center',
  },
  signatureTitle: {
    fontSize: 7,
    fontWeight: 'bold',
    color: '#000',
    marginTop: 5,
  },
  signatureSubtitle: {
    fontSize: 8,
    color: '#00BFD4',
  },
  signatureImage: {
    width: 120,
    height: 60,
  },
})
